module.exports = __webpack_public_path__ + "img/DP005C_001.f265132c.png";